export const formatPhone = (phone?: string | null) => {
  if (!phone) {
    return null;
  }

  return phone.replace(/[\s|(|)|-]/g, "");
};
